import { CategoryFirstLevel } from '@/shared/dtos/category-first-level';
import categoryModule from '@/store/modules/category-first-level.module';
import publicLayoutModule from '@/store/modules/public-layout.module';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { DxSelectBox } from 'devextreme-vue';
import offerDemandModule from '@/store/modules/offer-demand.module';
import { API } from '@/shared/api';
import { itiHttpService, itiMessageService, itiTokenService } from '@/iti-core-vue';
import fileModule from '@/store/modules/file.module';

@Component({
    components: {
        DxSelectBox
    },
})

export default class InicioWeb extends Vue {

    public name: string = '';
    public email: string = '';
    public subject: string = '';
    public message: string = '';
    public privacity: boolean = false;

    public async created() {
        await categoryModule.getCategoriesAnonymous();
        document.documentElement.scrollTop;
    }
    private categorySelect: number | null = null;

    public get categoryFirstLevelList() {
        var categoriesFirstLevel: CategoryFirstLevel[] = [];
        var emptyCategory = new CategoryFirstLevel();
        emptyCategory.id = -1;
        categoriesFirstLevel.push(emptyCategory);

        categoriesFirstLevel = categoriesFirstLevel.concat(categoryModule.categories);

        return categoriesFirstLevel;
    }

    public get language() {
        return this.$root.$i18n.locale.toString();
    }

    public goTo(path: string) {
        this.$router.push(path).catch(err => { });
        publicLayoutModule.setWebTab(path);
    }

    public search() {
        if (this.categorySelect && this.categorySelect > 0) {
            offerDemandModule.actualizarCategorySelect(this.categorySelect);
            this.$router.push('/inicio/search').catch(err => { });
        }
    }

    public goToPrivacity() {
        this.$router.push('/privacidad')
    }

    public async sendEmail() {
        if (this.privacity) {
            var emailValidation = this.email.includes('@') && this.email.split('@')[0] != '' && this.email.split('@')[1] != '';
            if (this.name != '' && this.subject != '' && this.email.includes('@') && emailValidation)
                itiHttpService.post(API.contactForm + '/SendEmail?name=' + this.name
                    + '&email=' + this.email + '&subject=' + this.subject + '&message=' + this.message, '')
                    .then(() => { itiMessageService.toast(this.$tc('contact-form-send'), 'success', 2000); })
                    .catch(() => { itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000); })
        }
    }
    public async gotToIndicadores() {
        if (process.env.VUE_APP_AREA_PUBLICA_FORMACION_ECONOMIA_CIRCULAR_ID != null && process.env.VUE_APP_AREA_PUBLICA_FORMACION_ECONOMIA_CIRCULAR_ARCHIVO_INDICADORES_ID != null) {
            var idOrigenEvento = process.env.VUE_APP_AREA_PUBLICA_FORMACION_ECONOMIA_CIRCULAR_ID;
            var fileID: number = parseInt(process.env.VUE_APP_AREA_PUBLICA_FORMACION_ECONOMIA_CIRCULAR_ARCHIVO_INDICADORES_ID);
            const e = {
                id: fileID,
                ambitId: idOrigenEvento
            }
            if (itiTokenService.hasToken())
                await fileModule.setFileToShow(e);
            sessionStorage.setItem('loginReturnURL', 'GestionDocumentalAreaColaborativa');
            sessionStorage.setItem('fileToShow', JSON.stringify(e));
            this.$router.push({ name: 'GestionDocumentalAreaColaborativa', params: { collaborativeAreaId: idOrigenEvento.toString() } });
        }
    }
}